import { createFileRoute } from "@tanstack/react-router"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import GroupChargeHistory from "@/components/group-charge-history"
import GroupChargeBuy from "@/components/buy/group"
import { useState } from "react"
import { ChargeProvider } from "@/stores/charge-store"
import { MultiChargeStoreProvider } from "@/stores/multi-charge-store"
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"

export enum GroupChargeStatus {
  pending = "در انتظار اجرا",
  doing = "در حال اجرا",
  done = "به اتمام رسیده",
  canceled = "لغو شده",
}

const UserGroupCharge = () => {
  const [tabs,setTabs] = useState('buy')

  return (
    <>

      <ChargeProvider>
    <MultiChargeStoreProvider>
        <Tabs defaultValue="buy" value={tabs} onValueChange={(value) => {
          setTabs(value)
        }}>
          <TabsList className="sticky top-10 inset-x-0 z-50">
            <TabsTrigger value="buy">خرید شارژ گروهی</TabsTrigger>
            <TabsTrigger value="list">تاریخچه شارژ گروهی</TabsTrigger>
          </TabsList>

          <TabsContent value="buy" className="grid grid-cols-1 md:grid-cols-2">
            <GroupChargeBuy onSuccess={() => {
              setTabs('list')
            }} />
          </TabsContent>

          <TabsContent value="list">
            <GroupChargeHistory />
          </TabsContent>
        </Tabs>
    </MultiChargeStoreProvider>
      </ChargeProvider>

    </>
  )
}

export const Route = createFileRoute("/group-charge/")({
  component: UserGroupCharge,
})
